import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=3bcfbe2c"
import script from "./Typography.vue?vue&type=script&lang=js"
export * from "./Typography.vue?vue&type=script&lang=js"
import style0 from "./Typography.vue?vue&type=style&index=0&id=3bcfbe2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports